// Stripe Elements appearance config, extracted VERBATIM from PaymentForm's
// `appearance` useMemo. A module-level constant has stable identity, so the
// component can memoize on it without recreating the object.

export const STRIPE_APPEARANCE = {
  theme: 'stripe',
  variables: {
    colorPrimary: '#A47743',
    colorBackground: '#FFFFFF',
    colorText: '#10213F',
    colorTextSecondary: '#4B5563',
    colorDanger: '#991B1B',
    fontFamily: 'Inter, -apple-system, BlinkMacSystemFont, Segoe UI, Roboto, Helvetica, Arial, sans-serif',
    fontSizeBase: '13px',
    fontWeightNormal: '400',
    spacingUnit: '4px',
    borderRadius: '7px'
  },
  rules: {
    '.AccordionItem': {
      border: '1px solid #E2E2E2',
      borderRadius: '7px',
      boxShadow: 'none'
    },
    '.Tab, .Block': {
      border: '1px solid #E2E2E2',
      borderRadius: '7px',
      boxShadow: 'none'
    },
    '.Input': {
      border: '1px solid #E2E2E2',
      borderRadius: '7px',
      boxShadow: 'none',
      color: '#10213F',
      fontSize: '13px',
      lineHeight: '1.4',
      padding: '10px 12px'
    },
    '.Input::placeholder': {
      color: '#59616D'
    },
    '.Input:focus, .Tab:focus': {
      borderColor: '#A47743',
      boxShadow: '0 0 0 2px #F5EFE6',
      outline: 'none'
    },
    '.Label': {
      color: '#10213F',
      fontSize: '13px',
      fontWeight: '600',
      letterSpacing: 'normal'
    },
    '.TabLabel': {
      color: '#A47743',
      fontSize: '13px',
      fontWeight: '500'
    },
    '.Error': {
      color: '#991B1B',
      fontSize: '13px'
    }
  }
};
